import App from './components/App';
import { Suspense, createRoot } from "@wordpress/element";

// console.log(blockData);

const domElement = document.getElementById("location-appointment-button");

if (domElement) {
    const root = createRoot(domElement);
    root.render(<Suspense fallback={<div>Loading...</div>}><App data={blockData} /></Suspense>);
}